import React from 'react';
import styles from './AdvtFullSize.module.css';
import { useGetParams } from '../../hooks/useGetParams';

import logo from '../../assets/images/logo.png';
const AdvtFullSize = React.memo(() => {
  const { titleFontSize, title } = useGetParams();

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleBlock}>
        {title &&
          title.split('\\n').map((str, i) => (
            <div
              key={str + i}
              className={styles.title}
              style={{ fontSize: `${titleFontSize}rem` }}
            >
              {str}
            </div>
          ))}
      </div>

      <img src={logo} alt="logo" className={styles.logo} />
    </div>
  );
});

export default AdvtFullSize;
